<template>
    <main class="w-full">
        <div v-if="!state.isLoading" class="pt-20 h-full">
            <div class="header">
                <h3 v-if="state.resultPlay['venues.city']">{{ state.resultPlay["home_team.name"] }} vs {{
            state.resultPlay["away_team.name"] }} @ {{
            state.resultPlay["venues.stadium"] }} -
                    {{ state.resultPlay["matches.start_date"].split('T')[0] }} - Inn:
                    {{ state.resultPlay["plays.innings"] }} Ovr: {{ state.resultPlay["plays.over"] }} Ball:
                    {{ state.resultPlay["plays.ball"] }} Delivery: {{ state.resultPlay["plays.delivery"] }}</h3>
            </div>
            <div class="row h-full px-6 mt-6" style="height: calc( 100vh - 12.5rem );">
                <div class="column side" style="display: flex; flex-direction: column; overflow: auto;">
                    <Panel class="border-solid border-2 rounded-md border-[#e5e7eb]" header="Players in play"
                        toggleable>
                        <div class="mb-2" v-for="item in playerItems" :key="item.name">
                            <Card style="width: 100%; overflow: hidden; ">
                                <template #header>
                                    <div class="bg-slate-200 h-10 px-4"
                                        style="align-content: center;display: flex;text-align: center;justify-content: center;margin-left: auto; align-items: center;">
                                        <div
                                            style="text-align: center;justify-content: center;display: flex;align-items: center;">
                                            {{ item.role }}
                                        </div>
                                        <Button
                                            style="margin-left: auto;text-align: center;justify-content: center; border-width: 0.1rem; border-color: black;height: fit-content;"
                                            class="px-1 " label="More" severity="secondary" />
                                    </div>
                                </template>
                                <template #title>
                                    <div>
                                        {{ item.name }}
                                    </div>
                                </template>
                                <template #subtitle>{{ item.place }}
                                </template>
                                <template #content>
                                    <div v-if="item.home">
                                        Home/Away: {{ item.home }} <br>
                                    </div>
                                    <div v-if="item.hand">
                                        Handedness: {{ item.hand }} <br>
                                    </div>
                                    <div v-if="item.style">
                                        Bowl Style: {{ item.style }} <br>
                                    </div>
                                </template>
                            </Card>
                        </div>
                    </Panel>
                    <Panel class="border-solid border-2 rounded-md border-[#e5e7eb]" header="Play Details"
                        style="margin-top:1rem ;" toggleable>
                        Wicket Fell: {{ state.resultPlay["plays.wicket_fell"] != 0 ? 'Yes' : 'No' }} <br>
                        Bowl End: {{ state.resultPlay["plays.bowl_end"] == 0 ? 'North' : 'South' }} <br>
                        Ball Speed From Hand: {{ state.resultPlay["plays.speed_from_hand_total"] }} <br>
                        Time Bowled: {{ state.resultPlay["plays.timestamp"] }} <br>
                        Break After Ball: {{ state.resultPlay["plays.break_after_ball"] != 0 ?
            state.resultPlay["plays.break_after_ball"]
            : 'No' }}
                    </Panel>
                </div>
                <div class="column middle play block h-full" style="">
                    <!-- <div > -->
                    <DataTabs style="text-transform: capitalize" :headers="videoHeaders" :team-manager-active="0"
                        class="mb-3" v-slot="slotProps" v-show="!noVideo && !isLoading">
                        <div style="height:calc(60vh)" class="pb-4">
                            <video-js :id="slotProps.header.replace(/\s/g, '') " class="video-js h-full w-full my-4 mt-2"
                                width="640" height="268" controls preload="auto"></video-js>
                        </div>
                    </DataTabs>
                    <!-- </div> -->
                    <div v-show="noVideo" class="justify-center h-full w-full my-4 text-center">
                        <p>There are no recorded videos for this play</p>
                    </div>
                    <ProgressSpinner v-if="isLoading" class="justify-center" attrs-color-black
                        style="width: 90px; height: 90px; margin-left: 45%; margin-top: 25%;" strokeWidth="5"
                        animationDuration="1s" aria-label="Loading" />
                </div>
            </div>
        </div>
        <ProgressSpinner v-else class="absolute m-auto left-0 right-0 top-0 bottom-0" attrs-color-black
            style="width: 90px; height: 90px" strokeWidth="5" animationDuration="1s" aria-label="Loading" />
    </main>
</template>

<script lang='ts' setup>
import Card from 'primevue/card';
import videojs from "video.js";
import "video.js/dist/video-js.css";
import Button from 'primevue/button';
import Panel from 'primevue/panel';
import ProgressSpinner from 'primevue/progressspinner';

import { useRoute } from 'vue-router'
const route = useRoute()
import { CubeQuery, SearchFilter, Data } from '@/models/queryBuilder'
import { ref, Ref, onMounted, onBeforeMount } from 'vue'
import axios from 'axios'
import { authStore } from "../store/index";
import { useApiStore } from "../store/api/api";
import { useVideoApiStore } from "../store/api/videoApi"
import DataTabs from '@/components/DataTabs.vue';
const auth = authStore();
const api = useApiStore();
const videoApi = useVideoApiStore();
const BASE_URL = 'https://sandbox.hyperlayer.virtualeye.com/video/'
const videoHeaders: Ref<string[]> = ref([])
let isLoading = ref(true)
let noVideo = ref(false)
let responseStore = null
let playerItems = ref([])
let headers = ref(['north', 'south east', 'south west'])

onMounted(async () => {
    await query(state.value.queryTable);
    await videoApi.authorize();
    await determineAvailableVideos()
})

const state = ref({
    queryTable: <CubeQuery>{
        dimensions: [
            "plays.play_key",
            "matches.match_type",
            "matches.day_nighter",
            "matches.country",
            "venues.city",
            "venues.stadium",
            "matches.start_date",
            "plays.timestamp",
            "home_team.name",
            "away_team.name",
            "bowling_team.name",
            "batting_team.name",
            "striker.display_name",
            "non_striker.display_name",
            "bowler.display_name",
            "plays.innings",
            "plays.over",
            "plays.delivery",
            "plays.ball",
            "plays.wicket_fell",
            "plays.bowl_end",
            "non_striker.home_away",
            "striker.home_away",
            "bowler.home_away",
            "bowler.team",
            "striker.team",
            "non_striker.team",
            "striker.bat_hand",
            "non_striker.bat_hand",
            "bowler.bat_hand",
            "bowler.bowl_style",
            "plays.break_after_ball"
        ],
        measures: ["plays.total_runs", "plays.wickets", "plays.wides", "plays.byes", "plays.leg_byes", "plays.runs", "plays.bowling_runs", "plays.speed_from_hand_total", "plays.no_balls"],
        order: {},
        filters: [{ "member": "plays.play_key", "operator": "equals", "values": [`${route.query.q}`] }],
        limit: 24,
        offset: 0
    },
    resultPlay: {
    },
    isLoading: true
})

async function query(query) {
    await api.queryGeneric(query).then(response => (state.value.resultPlay = JSON.parse(response.data).data[0]));
    // await api.get(`${process.env.VUE_APP_CUBE_BASE_URL}` + query, { headers: { "Authorization": `${auth.user.id_token}` } }).then(response => (state.value.resultPlay = response.data.data[0]))
    playerItemSetup();
    return
}

async function determineAvailableVideos() {
    let response = false

    isLoading.value = true
    for await (const key of headers.value) {
        responseStore = null
        await videoApi.fetchVideo(BASE_URL + route.query.q + `/${key.replace(/\s/g, "")}.m3u8`).then((value) => {
            if (value.data != undefined && !value.data.includes('DOCTYPE html')) {
                responseStore = value.data;
                videoHeaders.value.push(key);
            }
        });

        if (responseStore) {
            response = true
            var player = videojs(key.replace(/\s/g, ""), {
                html5: {
                    vhs: {
                        overrideNative: true,
                        limitRenditionByPlayerDimensions : false
                    },
                }
            });
            player.responsive(true);
            player.ready(function () {
                player.src({
                    src: BASE_URL + route.query.q + `/${key.replace(/\s/g, "")}.m3u8`,
                    type: "application/x-mpegURL",
                    withCredentials: true
                });
            });
        }
    }
    if (response === false) {
        noVideo.value = true
    }
    isLoading.value = false

}

function playerItemSetup() {
    playerItems.value.push({
        name: state.value.resultPlay["striker.display_name"],
        place: state.value.resultPlay["striker.team"],
        role: "Striker",
        home: state.value.resultPlay["striker.home_away"],
        hand: state.value.resultPlay["striker.bat_hand"]
    });
    playerItems.value.push({
        name: state.value.resultPlay["non_striker.display_name"],
        place: state.value.resultPlay["non_striker.team"],
        role: "Non Striker",
        home: state.value.resultPlay["non_striker.home_away"],
        hand: state.value.resultPlay["non_striker.bat_hand"]
    });
    playerItems.value.push({
        name: state.value.resultPlay["bowler.display_name"],
        place: state.value.resultPlay["bowler.team"],
        role: "Bowler",
        home: state.value.resultPlay["bowler.home_away"],
        hand: state.value.resultPlay["bowler.bat_hand"],
        style: state.value.resultPlay["bowler.bowl_style"]
    });
    state.value.isLoading = false
}

</script>

<style>
@keyframes p-progress-spinner-color {

    100%,
    0% {
        stroke: #36a8dd;
    }
}

html,
body {
    height: 100% !important
}

body {
    margin: 0 !important
}

#app {
    height: 100% !important
}

* {
    box-sizing: border-box;
}

body {
    font-family: Arial, Helvetica, sans-serif;
}

.header {
    background-color: #f1f1f1;
    padding: 30px;
    text-align: center;
    font-size: 20px;
}

.column {
    float: left;
    padding: 10px;
    height: 100%;
}

.column.side {
    width: 40%;
}

.column.middle {
    width: 60%;
    height: auto;
}

.row:after {
    content: "";
    display: table;
    clear: both;
}

.footer {
    background-color: #f1f1f1;
    padding: 10px;
    text-align: center;
}

.p-card-body {
    padding-top: 0 !important;
}

.p-card-title {
    margin-bottom: 0 !important;
}

/* Responsive layout - makes the three columns stack on top of each other instead of next to each other */
@media (max-width: 600px) {

    .column.side,
    .column.middle {
        width: 100%;
    }
}
</style>
